import React from 'react'
import { Link } from 'react-router-dom'
import { BackButton } from './AppShell'

interface CheckoutShellProps {
  onBack?: () => void
  logoLinksToDashboard?: boolean
  children: React.ReactNode
}

/**
 * White-canvas wrapper used to host Stripe's `EmbeddedCheckout`. Mirrors the
 * shell ResetProductPage already inlined for its checkout return view, but
 * lifted so GenericProductList and any future checkout surface can share it.
 *
 * Keeps the surface neutral so Stripe's iframe isn't fighting our chrome.
 */
export const CheckoutShell: React.FC<CheckoutShellProps> = ({
  onBack,
  logoLinksToDashboard = true,
  children,
}) => {
  const logo = (
    <img
      src="/img/dupr_dark.svg"
      alt="DUPR"
      className="h-6 md:h-8 transition-opacity hover:opacity-70"
    />
  )

  return (
    <div className="min-h-screen bg-[color:var(--surface-soft)]">
      <nav
        className="relative h-16 bg-[color:var(--surface)] border-b border-[color:var(--nav-border)] flex items-center px-4 md:px-12 text-[color:var(--ink-soft)]"
      >
        {onBack ? <BackButton onClick={onBack} /> : <span aria-hidden />}
        <div className="absolute left-1/2 -translate-x-1/2 flex items-center">
          {logoLinksToDashboard ? (
            <Link to="/dashboard" aria-label="Go to DUPR dashboard">
              {logo}
            </Link>
          ) : (
            logo
          )}
        </div>
      </nav>
      <div className="md:mt-10 md:mb-10">{children}</div>
    </div>
  )
}

export default CheckoutShell
